import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Fonts } from "@snapchat/snap-design-system";

export const lensPreviewFormSpecs = css`
    width: 397px;
    padding-left: 24px;

    > * {
        margin: 0;
    }
`;

export const SpecHeader = styled.h3`
    padding-bottom: 4px;

    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    color: ${Colors.Black.V200};
`;

export const GuideLink = styled.a`
    ${Fonts.Paragraph.P300};
    padding-left: 4px;
    color: ${Colors.Blue.V100};
    text-decoration: none;
`;

export const actionButtonStyle = css`
    cursor: pointer;

    min-height: 12px !important;
    margin-top: 8px;
    padding: 0 0 0 3px !important;

    font-size: 12px !important;
    font-weight: 500 !important;
    line-height: 12px;
    color: ${Colors.Blue.V100};
`;

export const RequirementsList = styled.ul`
    padding: 0 0 16px 16px;
`;

export const RequirementsListItem = styled.li`
    /* Matches LensPreviewForm.styles' LensPreviewText, so every line in this block — the bullets and
       the paragraphs around them — reads at one size instead of the bullets inheriting the modal's
       larger base. */
    font-size: 12px;
    font-weight: normal;
    line-height: 16px;
    color: ${Colors.Gray.V300};

    span {
        margin-left: -6px;
    }
`;
